import { api } from '@/lib/api';
import type { PreviewResponse, ValidateResponse, ExecuteResponse, CleanupResponse, MigrationMode } from './types';

const MIGRATION_TIMEOUT_MS = 180_000; // 3 minutes — matches web_api_server proxy timeout

export async function previewMigration(
  sourceOrganisationId: string,
  targetOrganisationId: string,
  mode: MigrationMode,
): Promise<PreviewResponse> {
  return api.post<PreviewResponse>('/v4/account-migration/preview', {
    sourceOrganisationId,
    targetOrganisationId,
    mode,
  });
}

export async function validateMigration(
  sourceOrganisationId: string,
  targetOrganisationId: string,
  mode: MigrationMode,
): Promise<ValidateResponse> {
  return api.post<ValidateResponse>('/v4/account-migration/validate', {
    sourceOrganisationId,
    targetOrganisationId,
    mode,
  });
}

export async function executeMigration(
  sourceOrganisationId: string,
  targetOrganisationId: string,
  mode: MigrationMode,
  archiveSource: boolean,
): Promise<ExecuteResponse> {
  return api.post<ExecuteResponse>('/v4/account-migration/execute', {
    sourceOrganisationId,
    targetOrganisationId,
    mode,
    archiveSource,
  }, { timeoutMs: MIGRATION_TIMEOUT_MS });
}

export async function cleanupMigration(batchId: string): Promise<CleanupResponse> {
  return api.post<CleanupResponse>('/v4/account-migration/cleanup', { batchId }, { timeoutMs: MIGRATION_TIMEOUT_MS });
}
